import React, { useEffect, useState } from "react";
import { Check, Pencil, X } from "lucide-react";
import Button from "@/components/button/Button";
import { MultiSelect, type Option } from "@/components/forms/MultiSelect";
import type { CombinationRowProps } from "./RoleCombinations.types";

export default function CombinationRow(
    {
        combination,
        roles,
        implicitRoleIds,
        isEditing,
        onEdit,
        onSave,
        onCancel,

    }: Readonly<CombinationRowProps>) {
    const [editedAllowedIds, setEditedAllowedIds] = useState<string[]>(combination.allowedRoleIds);

    useEffect(() => {
        if (isEditing) {
            setEditedAllowedIds(combination.allowedRoleIds);
        }
    }, [isEditing, combination.allowedRoleIds]);

    const roleName = roles.find(r => r.id === combination.roleId)?.name ?? combination.roleId;

    const selectOptions: Option[] = roles
        .filter(r => r.id !== combination.roleId)
        .map(r => ({ value: r.id, label: r.name }));

    const selectedOptions: Option[] = editedAllowedIds
        .map(id => selectOptions.find(o => o.value === id))
        .filter(Boolean) as Option[];

    const explicitNames = combination.allowedRoleIds
        .map(id => roles.find(r => r.id === id)?.name ?? id);

    const implicitNames = implicitRoleIds
        .map(id => roles.find(r => r.id === id)?.name ?? id);

    return (
        <tr>
            <td className="border border-gray-300 px-2 py-1 font-bold align-middle">{roleName}</td>
            <td className="border border-gray-300 px-2 py-1 text-left align-middle">
                {isEditing ? (
                    <MultiSelect
                        options={selectOptions}
                        value={selectedOptions}
                        onChange={(newValue) => setEditedAllowedIds(newValue.map(o => o.value))}
                        placeholder="Sélectionner les rôles permis..."
                        closeMenuOnSelect={false}
                        menuPortalTarget={document.body}
                    />
                ) : (
                    <div>
                        <span>{explicitNames.length > 0 ? explicitNames.join(", ") :
                            <span className="text-gray-400 italic">Aucun rôle sélectionné</span>}</span>
                        {implicitNames.length > 0 && (
                            <div className="text-blue-500 text-sm mt-1">
                                implicites : {implicitNames.join(", ")}
                            </div>
                        )}
                    </div>
                )}
            </td>
            <td className="border border-gray-300 px-2 py-1 align-middle">
                <div className="flex gap-1 justify-center">
                    {isEditing ? (
                        <>
                            <Button onClick={() => onSave(editedAllowedIds)} icon={<Check size={20}/>} type="success"/>
                            <Button onClick={onCancel} icon={<X size={20}/>} type="danger"/>
                        </>
                    ) : (
                        <Button onClick={onEdit} icon={<Pencil size={20}/>} type="primary"/>
                    )}
                </div>
            </td>
        </tr>
    );
}
